// Curated finished-room photographs; construction, family-testing and duplicate views excluded.
export const BLISS_PORTFOLIO_PROJECTS = [
  {
    "id": 82662,
    "image": "/media/portfolio/curated-82662.jpg",
    "fullImage": "/media/portfolio/curated-82662.jpg",
    "name": "Ernst model",
    "detail": "Custom bunk rooms by Bliss"
  },
  {
    "id": 82316,
    "image": "/media/portfolio/curated-82316.jpg",
    "fullImage": "/media/portfolio/curated-82316.jpg",
    "name": "Drain model",
    "detail": "Custom bunk rooms by Bliss"
  },
  {
    "id": 82071,
    "image": "/media/portfolio/curated-82071.jpg",
    "fullImage": "/media/portfolio/curated-82071.jpg",
    "name": "Chinchilla model",
    "detail": "Custom bunk rooms by Bliss"
  },
  {
    "id": 81393,
    "image": "/media/portfolio/curated-81393.jpg",
    "fullImage": "/media/portfolio/curated-81393.jpg",
    "name": "Goulding model",
    "detail": "Custom bunk rooms by Bliss"
  },
  {
    "id": 82188,
    "image": "/media/portfolio/curated-82188.jpg",
    "fullImage": "/media/portfolio/curated-82188.jpg",
    "name": "Rothman model",
    "detail": "Custom bunk rooms by Bliss"
  }
] as const
